application.register("part_dialog_basket_gifts", class extends Stimulus.Controller {
    highlightGifts() {
        const gifts = document.documentElement.querySelector('.elm_part_gifts')
        if(!gifts) return

        gifts.scrollIntoView({behavior: 'smooth'})

        if(!gifts.classList.contains('state--active')) {
            const giftsTrigger = gifts.querySelector('.elm_gifts_head')
            if(giftsTrigger) {
                giftsTrigger.click()
            }
        }

        gifts.animate([
            {
                boxShadow: '0 0 0 transparent'
            },
            {
                boxShadow: '0 0 3rem #F4742B'
            },
            {
                boxShadow: '0 0 0 transparent'
            },
        ], {
            duration: 1500,
            iterations: 3
        })
    }
});
